var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C16.96 3 21 7.04 21 12C21 16.96 16.96 21 12 21C7.04 21 3 16.96 3 12C3 7.04 7.04 3 12 3ZM12 4.5C7.86 4.5 4.5 7.86 4.5 12C4.5 16.14 7.86 19.5 12 19.5C16.14 19.5 19.5 16.14 19.5 12C19.5 7.86 16.14 4.5 12 4.5ZM11.8701 14.7295C12.5499 14.7295 12.8397 15.0499 12.8398 15.5996C12.8398 16.1496 12.55 16.4599 11.8701 16.46C11.1901 16.46 10.9004 16.2196 10.9004 15.5996C10.9005 15.0498 11.1903 14.7295 11.8701 14.7295ZM11.9004 7.9502C13.6401 7.95032 14.4902 8.76014 14.4902 10.04C14.4902 11.25 13.7696 12.0797 12.5996 12.6797L12.6104 12.6904L12.54 13.9102H11.1797L11.0898 12.0498C12.0698 11.5298 12.7197 11.05 12.7197 10.3301C12.7197 9.81018 12.3301 9.54014 11.6504 9.54004C10.9705 9.54004 10.4202 9.76979 9.99023 10.1396L9.37012 8.75977C9.94013 8.28984 10.8805 7.9502 11.9004 7.9502Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Question_Icon.bc42563986615781c779173f91eb4072.svg";